import React, { Component } from "react";
import HomeHeaderFinger from "./HomeHeaderFinger";
import "../../../styles/pages/home/HomeHeader.css";
import gradientLogo from "../../../assets/images/callgage-gradient-logo.png";
import gradientLogoMobile from "../../../assets/images/callgage-gradient-logo-mobile.png";

export default class HomeHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onLoadAnim: false
    };
  }
  componentDidMount() {
    this.setState({ onLoadAnim: true });
  }

  render() {
    return (
      <div
        className={
          "HomeHeader" + (this.state.onLoadAnim ? " on-load-anim" : "")
        }
      >
        <div className="logo-container">
          <img
            className="logo desktop"
            draggable="false"
            src={gradientLogo}
            alt="Large Callgage logo."
          />
          <img
            className="logo mobile"
            draggable="false"
            src={gradientLogoMobile}
            alt="Mobile Callgage logo."
          />
        </div>

        <div className="separator" />

        <div className="sub-text-container">
          <div className="sub-text">Web Design & Development</div>
        </div>

        <HomeHeaderFinger />
      </div>
    );
  }
}
